export const SET_GEO_FEATURES_SUCCESS = 'geoFeatures/SET_GEO_FEATURES_SUCCESS';
